export default __webpack_public_path__ + "static/media/wadapp-min.70464c47.png";